export function checkAvailability(motor, power){
    if (!motor || !power) return false;

    return motor.kw >= power;
}

//filter function
export function byType(type, subtype, subtypeValue){
  return function(m) {
    return m.type === type && m[subtype] === subtypeValue;
  }
}
